import { useContext } from "react";

import AlertModalContext from "./AlertModalContext";

export default function useAlertModal() {
  return useContext(AlertModalContext);
}

export { useAlertModal };
